<!--
 * @Auther: 罗耀祖
 * @Date: 2022-04-09 16:19:31
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-14 13:38:11
 * @name: 导出列表
 * @Description: 导出列表
 * @FilePath: \project\src\components\afterSale\dialog-output.vue
 * @Author: desktop
-->
<template>
  <el-dialog title="导出列表" :visible.sync="show" @close="close">
    <div class="list" v-if="list.length > 0">
      <a
        :href="item.file_path"
        target="_blank"
        class="item"
        v-for="item of list"
        :key="item.name"
        >{{ item.name }}</a
      >
    </div>
    <div class="tips" v-else>暂无可导出文件</div>
  </el-dialog>
</template>
<script>
import issueService from "@/module/issue/issue.service";
export default {
  data() {
    return {
      issueService: new issueService(),
      list: [],
      show: false,
    };
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 打开弹窗
     * @param {Object} row 行信息
     */
    open(row) {
      console.log(row);
      this.issueService
        .issuePrint({ issue_id: row.id, run_process_id: row.run_process_id })
        .then((res) => {
          this.list = res.data
            .filter((x) => x.file_path)
            .map((x) => {
              x.file_path = process.env.VUE_APP_BASE_API + x.file_path;
              return x;
            });
          this.show = true;
        });
    },
    close() {
      this.list = [];
    },
  },
};
</script>
<style lang="scss" scoped>
.list {
  width: 100%;
  padding: 0 20px;
  @extend .et-flex-column-normal;
  .item:not(:first-child) {
    margin-top: 20px;
  }
}
.tips {
  width: 100%;
  padding: 20px 0;
  @extend .et-flex-center;
  font-size: $Vars-font-miniTitle-size;
  color: $Vars-font-placeholder-color;
}
</style>